import React, { useEffect, useRef, useState } from 'react';
import { useInView } from 'framer-motion';
import stats from '../../data/stats.json';
import './Stats.css';

// Parse "50M+", "4.2x", "200+", "-43%" into { prefix, number, suffix, decimals }
function parseValue(raw) {
  const match = String(raw).match(/^(\D*?)(-?\d+(?:\.\d+)?)(\D*)$/);
  if (!match) return { prefix: '', number: 0, suffix: String(raw), decimals: 0 };
  const [, prefix, num, suffix] = match;
  const decimals = num.includes('.') ? num.split('.')[1].length : 0;
  return { prefix, number: parseFloat(num), suffix, decimals };
}

function CountUp({ value, play }) {
  const { prefix, number, suffix, decimals } = parseValue(value);
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!play) return;
    let raf;
    const duration = 1400;
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(number * eased);
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [play, number]);

  return (
    <span>
      {prefix}
      {display.toFixed(decimals)}
      {suffix}
    </span>
  );
}

const Stats = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.4 });

  return (
    <section className="stats" ref={ref}>
      <div className="stats__inner tra-container">
        {stats.map((s, i) => (
          <div className="stats__item" key={s.label}>
            <span className="stats__value">
              <CountUp value={s.value} play={inView} />
            </span>
            <span className="stats__label">{s.label}</span>
            {i < stats.length - 1 && <span className="stats__divider" aria-hidden="true" />}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
